"use client";

import React, { useState } from "react";
import { addService } from "../../../components/http";
import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextInput from "../../../components/inputs/TextInput";
import DurationInput from "../../../components/inputs/DurationInput";
import ButtonsGroup from "../../../components/PopUps/ButtonsGroup";
import styles from "./ServicePage.module.scss";

const ServiceAddPopup = ({ open, onClose, onServiceAdded }) => {
  const { t } = useTranslation();

  const initialServiceState = {
    name: "",
    price: "",
    duration: { days: 0, hours: 0, minutes: 0 },
  };

  const [service, setService] = useState(initialServiceState);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setService((prev) => ({ ...prev, [name]: value }));
  };

  const handleDurationChange = (duration) => {
    setService((prev) => ({ ...prev, duration }));
  };

  const formatDurationToISO = () => {
    const { days, hours, minutes } = service.duration;
    let isoString = "P";

    if (days > 0) isoString += `${days}D`;
    if (hours > 0 || minutes > 0) {
      isoString += "T";
      if (hours > 0) isoString += `${hours}H`;
      if (minutes > 0) isoString += `${minutes}M`;
    }

    return isoString === "P" ? "" : isoString; 
  };

  const handleSave = async () => {
    const formattedDuration = formatDurationToISO();
    if (!service.name || service.price <= 0 || !formattedDuration) {
      alert(t("service.add.errorEmptyFields"));
      return;
    }

    try {
      await addService({
        name: service.name,
        price: parseFloat(service.price),
        duration: formattedDuration,
      });
      alert(t("service.add.successMessage"));
      onServiceAdded();
      handleClose();
    } catch (error) {
      console.error(t("service.add.errorAddingService"), error);
      alert(t("service.add.errorSavingService"));
    }
  };

  const handleClose = () => {
    setService(initialServiceState);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} className={styles.modalContainer}>
      <div className={styles.modalContent}>
        <h2 className={styles.title}>{t("service.add.title")}</h2>

        <div className={styles.inputsContainer}>
          <TextInput
            label={t("service.add.name")}
            name="name"
            value={service.name}
            onChange={handleInputChange}
            placeholder={t("service.add.name")}
            required={true}
          />

          <TextInput
            label={t("service.add.price")}
            name="price"
            value={service.price}
            onChange={handleInputChange}
            placeholder={t("service.add.price")}
            type="number"
          />

          <DurationInput
            label={t("service.add.duration")}
            value={service.duration}
            onChange={handleDurationChange}
          />
        </div>

        <ButtonsGroup
          onSave={handleSave}
          onCancel={handleClose}
          saveText={t("service.add.save")}
          cancelText={t("service.add.cancel")}
        />
      </div>
    </Modal>
  );
};

export default ServiceAddPopup;
